import { createPortalSupabaseClient } from './supabase';

export const supabase = createPortalSupabaseClient(false);
